export const employees = [
  {
    id: "LSP-IN36",
    name: "Jangam Naga Raju",
    dob: "1975-04-01",
    joiningDate: "2026-01-05",
  },
  {
    id: "LSP-IN34",
    name: "PVS Anil Patnaik",
    dob: "2004-04-21",
    joiningDate: "2025-08-01",
  },
  {
    id: "LSP-IN35",
    name: "Vankayala Jahnavi Naga Sai Lakshmi",
    dob: "2003-12-24",
    joiningDate: "2025-08-01",
  },
  {
    id: "LSP-IN33",
    name: "VENKATESHPRABHU R",
    dob: "1987-05-28",
    joiningDate: "2025-05-15",
  },
  {
    id: "LSP-IN32",
    name: "M Manikanta Pavankumar",
    dob: "1993-07-20",
    joiningDate: "2025-03-01",
  },
  {
    id: "LSP-IN30",
    name: "Chinthapalli Keerthana",
    dob: "2002-12-25",
    joiningDate: "2024-10-10",
  },
  {
    id: "LSP-IN29",
    name: "Borampet Bhavani",
    dob: "2001-09-15",
    joiningDate: "2024-10-01",
  },
  {
    id: "LSP-IN27",
    name: "Ritusree Mahapatra",
    dob: "1998-10-30",
    joiningDate: "2024-07-02",
  },
  {
    id: "LSP-IN26",
    name: "Srivaishnavi Chelikam",
    dob: "2002-05-24",
    joiningDate: "2024-02-11",
  },
  {
    id: "LSP-IN24",
    name: "Kiran SG",
    dob: "1999-07-06",
    joiningDate: "2023-10-01",
  },
  {
    id: "LSP-IN20",
    name: "Dondapati Naveen",
    dob: "1999-10-19",
    joiningDate: "2023-07-01",
  },
  {
    id: "LSP-IN17",
    name: "K Bapayya",
    dob: "1983-07-21",
    joiningDate: "2023-05-31",
  },
  {
    id: "LSP-IN5",
    name: "Aare Nikhil Kumar",
    dob: "2000-08-24",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN10",
    name: "Adepu Mayuri",
    dob: "1991-08-12",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN7",
    name: "Jinin K Jose",
    dob: "1995-02-03",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN12",
    name: "Jugal Kishore Bhandari",
    dob: "1987-02-06",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN9",
    name: "Mohammed Ubed",
    dob: "1999-03-06",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN15",
    name: "Sandhya Dharavath",
    dob: "1998-12-24",
    joiningDate: "2023-01-01",
  },
  {
    id: "LSP-IN13",
    name: "Venkata Ramana Jupudi",
    dob: "1961-01-01",
    joiningDate: "2023-01-01",
  },
];